export default {
  getPlanilha(state) {
    return (nomePlanilha) => {
      const planilha = state.planilhas[nomePlanilha];

      const template = {
        colunas: [],
        colunasExportar: [],
      };

      return planilha || template;
    };
  },
  getPlanilhaProcesso(state) {
    return state.planilhas.processo;
  },
  getPlanilhaCambio(state) {
    return state.planilhas.cambio;
  },
  getPlanilhaEstoque(state) {
    return state.planilhas.estoque;
  },
};
